// extracted by mini-css-extract-plugin
export default {"row":"rowstatsnote_row__a5tmJ","rank":"rowstatsnote_rank__NJrJz","totalNote":"rowstatsnote_totalNote__LJBlT","gauge":"rowstatsnote_gauge__YjD9T","meter":"rowstatsnote_meter__oxVNl"};